// 审批模版管理
import http from '@/assets/js/interceptor';
import util from '@/assets/js/util';
// 获取列表
export function getTempApprovalManageList (filter) {
  return http.get('/tplConfig/selectPage', { params: filter, domainType: 'bpmApi' });
}
// 禁用
export function disableStatus (id) {
  return http.put(`/tplConfig/disable/${id}`, {}, { domainType: 'bpmApi' });
}
// 启用
export function enableStatus (id) {
  return http.put(`/tplConfig/enable/${id}`, {}, { domainType: 'bpmApi' });
}
// 复制
export function copyRow (id) {
  return http.post(`/tplConfig/copy/${id}`, {}, { domainType: 'bpmApi' });
}
